import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {TableColumn, TableSettings} from "../../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../../common/AbstractListView";
import lockRed from '../../../../img/lock_red.png';
import constants from '../../../../constants';
import {Search} from "../../../../filtering";
import {NavigationType, openNewPage} from '../../../../util/navigationHelpers';
import * as XCol from '../../../../framework.core/XExportColumn';
import {
  DateRenderer,DateTimeRenderer,FloatRenderer,TextAlignLeftRenderer,TextRenderer
} from '../../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../../uiControls/UniqueLinkButton';
import PrimaryButton from '../../../../ui/PrimaryButton';
import ApplicationContext from '../../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../../common/JobListViewContext';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../../ui/ActionButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import {getTbNameByJobName, JobNames} from "../../../../framework.core/JobNames";
import {accountingJournalList} from "../../tableSettings";
import ListViewShortcutMenu from '../../../common/ListViewShortcutMenu';
import IfmsModal from "../../../../ui/IfmsModal";
import SearchJournal from "./more/SearchJournal";
import JournalVoucher from "./more/JournalVoucher";
import GeneralLedgerDetails from '../../reports/GeneralLedger';
import { DocumentType } from '../../../../framework.core/DocumentType';
import ToolboxMenuItem from '../../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../../ui/menu/Menu';
import { JournalLedgerListItem } from '../../../../fms.data/models/JournalLedgerListItem';
import { SuntekSettings, SystemSettings } from '../../../../ifmsTypes';
import { FmsSecTask, ListFilterType } from '../../../../fms.core/constants';
import { findSecurityTask } from '../../../../util';
import { StatusNotUseFileLockedRenderer } from '../../../common/commonListRenderers';
import useExternalScreenFilter from '../../../../hooks/useExternalScreenFilter';
import _ from 'lodash';
import { Decimalformat } from '../../../common/commonExportFormat';

function IndicatorRenderer({ data, row}:any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;

  return (
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  // const sourceUrl = `${history.location.pathname}${history.location.search}`;
  const operation = 'accounting';
  const appContext = useContext(ApplicationContext);

  const selectedElement = jobListContext.selectedElement as JournalLedgerListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();

  async function openSpecialJournalView(openMenu: string) {
    if (openMenu == 'CreditEntry' || openMenu === 'DebitEntry' || openMenu === 'BeginningJournal') {
      if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acJournal/add`)) {
        await showGlobalOkDialog(<p>New operation is already in progress</p>);
        return;
      }

      //let tbId = "0";
      let mode = "add"
      let fkey = "0";
      let seq = "0";
      let jourType = "";
      let tbType = "10";

      if (openMenu === 'DebitEntry') {
        jourType = "DR";
      }
      else if (openMenu === 'CreditEntry') {
        jourType = "CR";
      }
      else if (openMenu === 'BeginningJournal') {
        var apiResult = await appContext.api.getBeginningJournal();
        if (!apiResult || apiResult.length <= 0) {

        } else {
          jourType = "B";
          mode = _.isEmpty(apiResult.result[0]) ? "add" : "view"
          //tbId = _.isEmpty(apiResult[0]) ? "0" : apiResult[0]; // formPara
          fkey = _.isEmpty(apiResult.result[0]) ? "0" : `10T_SLIPHD${apiResult.result[0]}${apiResult.result[3]}`; // formPara2
          seq = _.isEmpty(apiResult.result[1]) ? "0" : apiResult.result[1]; // formPara3
          tbType = _.isEmpty(apiResult.result[2]) ? "10" : apiResult.result[2]; // formPara4
        }
      }

      openNewPage(history, `/${operation}/acJournal/${mode}/${fkey}/${seq}/${jourType}/${tbType}`, NavigationType.newPage);
      return;
    }
  }

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acJournal/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    openNewPage(history, `/${operation}/acJournal/add/0/0/T/10`, NavigationType.newPage);
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    // Edit Button도 View 모드로 동작후에 내부에서 Amend로 Edit Mode로 동작한다.
    // if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acJournal/edit`)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
    //   return;
    // }

    const fkey = selectedElement.fKey;
    const seq = selectedElement.seq;
    const type = selectedElement.type;
    const tbType = selectedElement.tbType;
    const editUrl = `/${operation}/acJournal/view/${fkey}/${seq}/${type}/${tbType}`;
    const viewUrl = `/${operation}/acJournal/view/${fkey}/${seq}/${type}/${tbType}`;

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }
    const fkey = selectedElement.fKey;
    const seq = selectedElement.seq;
    const type = selectedElement.type;
    const tbType = selectedElement.tbType;
    const editUrl = `/${operation}/acJournal/view/${fkey}/${seq}/${type}/${tbType}`;
    const viewUrl = `/${operation}/acJournal/view/${fkey}/${seq}/${type}/${tbType}`;

    const listSec = findSecurityTask(appContext, FmsSecTask.AcctSlipJournalList);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acJournal/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const fkey = selectedElement.fKey;
    const seq = selectedElement.seq;
    const type = selectedElement.type;
    const tbType = selectedElement.tbType;
    
    openNewPage(history, `/${operation}/acJournal/add/${fkey}/${seq}/${type}/${tbType}`, NavigationType.newPage);
  }

  return {create, edit, view, copy, openSpecialJournalView, operation};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, edit, view, copy } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as JournalLedgerListItem;

  const appContext = useContext(ApplicationContext);
  
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctSlipJournalList);

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit },
    { label: 'Edit', shortcut: 'F3', separator: true, hidden: !listSec?.grantEdit },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: true, hidden: !listSec?.grantAdd, disabled: selectedElement.type !== "T" },
    { label: 'Search', shortcut: 'F5', separator: false },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="journal-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    index,
    hidden: i?.hidden ?? false,
    disabled: i?.disabled ?? false
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        copy();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

//function AfterMemoLogButtonCommands() {
  // const jobListContext = useContext(JobListViewContext);
  // const appContext = useContext(ApplicationContext);
  //const [listFilterIsAll, setListFilterIsAll] = useState(true);

  // useEffect(() => {
  //   setListFilterIsAll(appContext.journalType === 0);
  //   changeJournalListData(appContext.journalType === 0);
  // },
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // [jobListContext.data]);

  // async function changeJournalListData(isAll : boolean){
  //   const listFilterType = isAll ? ListFilterType.All : ListFilterType.WithoutCancelReverser;    
  //   jobListContext.setListFilterType(listFilterType);
    
  //   //jobListContext.setJournalType(listFilterType);
  //   //<240513.dwshin filter type를 설정하면 자동으로 list를 reload 하므로, 아래 api를 call 할 이유가 없음.
  //   // const apiResult = await appContext.api.getListItems(JobNames.SlipJournal, 
  //   //   'JournalLedgerListItem',
  //   // JournalLedgerListItem.calculateSearchParameters(jobListContext.search, JournalLedgerListItem.MapSearchFields),
  //   // 1,
  //   // jobListContext.search.pageSize, undefined, isAll ? ListFilterType.All : ListFilterType.WithoutCancelReverser);

  //   // if(!apiResult || !apiResult.entities || apiResult.entities.length <= 0 ) {
  //   //   return { data: [], totalCount: 0};
  //   // }

  //   // jobListContext.setData && jobListContext.setData(JournalLedgerListItem.formatData(apiResult.entities), apiResult.totalCount);
  //   //240513.dwshin>
  // }

  // const allIcon = <img height="20px" width='20px' src={listFilterIsAll ? jrnlAll24_gray : jrnlAll24_yellow} style={{ position: 'relative', top: '-3px' }} alt="All List" />
  // const excel24Icon = <img height="20px" width='20px' src={!listFilterIsAll ? jrnlExcl24_gray : jrnlExcl24_yellow} style={{ position: 'relative', top: '-3px' }} alt="W/O Cancel/Reverse" />

  // return (
  //   <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} style={{ height: '22px' }}>
  //     <BlackInverseButton
  //       size='small'
  //       name='journal-All-Button'
  //       data-tooltip="All List"
  //       notsetbackcolorwhendisabled={'true'}
  //       disabled={listFilterIsAll}
  //       onClick={async () => { 
  //         appContext.setJournalType(0);
  //         await changeJournalListData(!listFilterIsAll) }}>{allIcon}
  //     </BlackInverseButton>&nbsp;
  //     <BlackInverseButton
  //       size='small'
  //       name='journal-reverse-Button'
  //       data-tooltip="W/O Cancel/Reverse"
  //       notsetbackcolorwhendisabled={'true'}
  //       disabled={!listFilterIsAll}
  //       onClick={async () => { 
  //         appContext.setJournalType(1);
  //         await changeJournalListData(!listFilterIsAll) }}>{excel24Icon}
  //     </BlackInverseButton>&nbsp;
  //   </div>
  // )
//}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem | null>(null);

  const selectedElement = jobListContext.selectedElement as JournalLedgerListItem;

  const { edit, view, copy, openSpecialJournalView, operation } = useSelectedOperations();

  const searchJournalSec = appContext.securityGrants?.find(x => x.securityTaskCode === FmsSecTask.AcctSearchJournal);
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctSlipJournalList);
  const hasSelectedRow = !!selectedElement;

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acJournal/add`);
  }

  //const hasSelectedRow = false;
  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd && selectedElement.type === "T";

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className='ifms-common-no-vertical-separator'>
        <UniqueLinkButton name='journal-list-add-button' display="primary" size="regular" link={`/${operation}/acJournal/add/0/0/T/10`} disabled={!canBeAdd} label="New" />&nbsp;
        <PrimaryButton name='journal-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='journal-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name='journal-list-copy-button' size="regular" disabled={!canBeCopied} onClick={copy}>Copy</PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        {(searchJournalSec?.grantRead || appContext.user?.isSuntekAdmin) &&
          <>
            <PrimaryButton name='journal-list-search-button' size="regular" 
              onClick={() => setSelectedPopupMenuItem({ 
                label: 'Search Journal', separator: false, 
                popupComponent: 
                <SearchJournal 
                  jobName={JobNames.SearchJournal} 
                  selectedElementId={selectedElement?.id}
                  onPopupClose={onPopupClose}
                />,
              })}>Search Journal
            </PrimaryButton>&nbsp;
          </>
        }
        <PrimaryButton name='journal-list-book-button' size="regular" onClick={() => setSelectedPopupMenuItem({
          label: 'Journal Book', separator: false, popupComponent: <GeneralLedgerDetails documentType={DocumentType.GeneralLedger} />, // General Ledger와 동일한 UI를 사용한다.
        })}>Journal Book</PrimaryButton>&nbsp;
        <PrimaryButton name='journal-list-voucher-button' size="regular" onClick={() => setSelectedPopupMenuItem({
          label: 'Journal Voucher', separator: false, popupComponent: <JournalVoucher />,
        })}>Journal Voucher</PrimaryButton>
      </div>
      {(appContext.suntekSettings?.company?.companyId === "FSSUNTEK" || appContext.user?.isSuntekAdmin) &&
        <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
          <>
            <PrimaryButton
              name='journal-list-debitEntry-button'
              size="regular"
              onClick={() => { openSpecialJournalView('DebitEntry'); }}>
              Debit Entry
            </PrimaryButton>&nbsp;
          </>
          <>
            <PrimaryButton
              name='journal-list-creditEntry-button'
              size="regular"
              onClick={() => { openSpecialJournalView('CreditEntry'); }}>
              Credit Entry
            </PrimaryButton>&nbsp;
          </>
          <>
            <PrimaryButton
              name='journal-list-beginningJournal-button'
              size="regular"
              onClick={() => { openSpecialJournalView('BeginningJournal'); }}>
              Beginning Journal
            </PrimaryButton>&nbsp;
          </>
        </div>
      }
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctSlipJournalList);
  const selectedElement = jobListContext.selectedElement as JournalLedgerListItem;

  const {create, edit, view, copy} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {

    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd && selectedElement.type === "T")
        copy();
    } 

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F9', 'F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  
  return (
    <></>
  );
}

//<pt220903: portal>
export function useJournal() {
  const history = useHistory();
  const {setFilterForScreenExternally} = useExternalScreenFilter();

  function switchJournal(jobName:JobNames, jobId:number, branch:string = '', searchModel:JournalLedgerListItem|null = null) {
    if(jobName === JobNames.None || jobId < 0) {
      return;   // Nothing to do
    }

    if(searchModel === null) {
      searchModel = new JournalLedgerListItem();
    }

    const tbName = getTbNameByJobName(jobName);
    switch(jobName) {
      case JobNames.PayrollSummary:
      case JobNames.Payroll2:
      case JobNames.Invoice:
      case JobNames.GInvo:
      case JobNames.WHStorageInv:
      case JobNames.WHInvoice:
      case JobNames.Bill:
      case JobNames.GBill:
      case JobNames.WHBill:
      case JobNames.CrDb:
      case JobNames.WHCrDb:
      case JobNames.CustPayment:
      case JobNames.BillPayment:
      case JobNames.CCPayment:
      case JobNames.AgntPayment:
      case JobNames.OIHbl:
      case JobNames.OEHbl:
      case JobNames.AIHbl:
      case JobNames.AEHbl:
      case JobNames.SalesTaxReturn:
      case JobNames.BankTransfer:
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      
      case JobNames.OIMbl:
      case JobNames.OEMbl:
      case JobNames.AIMbl:
      case JobNames.AEMbl:
      case JobNames.OtherOP:
      case JobNames.WHRcv:
      case JobNames.WHShip:
        searchModel.mtbName = tbName.length > 10 ? tbName.substring(0, 10) : tbName;
        searchModel.mblId = jobId;
        break;

      case JobNames.BTOrder:  
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      case JobNames.BTLoadPlan:
        searchModel.mtbName = tbName;
        searchModel.mblId = jobId;
        break;

      case JobNames.PrepaidExpenseAdjustment:
        searchModel.tbIndex = '11';
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      
      case JobNames.DepreciationAdjustment:
        searchModel.tbIndex = "12";
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      case JobNames.AmortizationAdjustment:
        searchModel.tbIndex = "13";
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      case JobNames.BadDebtExpense:
        searchModel.tbIndex = "16";
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      case JobNames.IncomeTaxAdjustment:
        searchModel.tbIndex = "17";
        searchModel.tbName = tbName;
        searchModel.tbId = jobId;
        break;
      case JobNames.SlipJournal:
          break;
      default:
          jobName = JobNames.None;
          break;
    }

    if(searchModel.tbId && searchModel.tbId > 0) searchModel.searchField.push('TBId');
    if(searchModel.tbName) searchModel.searchField.push('TBName');
    if(searchModel.mblId && searchModel.mblId > 0) searchModel.searchField.push('MBLId');
    if(searchModel.mtbName) searchModel.searchField.push('MTBName');
    if(searchModel.tbIndex) searchModel.searchField.push('TBIndex');
    if(branch) {
      searchModel.branch = branch;
      searchModel.searchField.push('Branch');
    }

    setFilterForScreenExternally('/common/joblistview/acJournal/accounting', 
    // pass only searchModel
    '', '', '', '', false, false, searchModel);
    openNewPage(history, '/common/joblistview/acJournal/accounting', NavigationType.newPage);
  }

  return { switchJournal };
}

class JournalListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    // const listFilterType = search.listType === ListFilterType.WithoutCancelReverser ? ListFilterType.WithoutCancelReverser : ListFilterType.All;
    const listFilterType = ListFilterType.All;
    const apiResult = await api.getListItems(JobNames.SlipJournal,
      'JournalLedgerListItem',
      JournalLedgerListItem.calculateSearchParameters(search, JournalLedgerListItem.MapSearchFields),
      1,
      search.pageSize, undefined, listFilterType);

    if(!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return { data: [], totalCount: 0};
    }

    return { data: JournalLedgerListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(_: string | undefined, systemSettings: SystemSettings | undefined): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    return JournalLedgerListItem.getExportCollection(useBranch).map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'exRate')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={4} />;
        else if (x.dataIndex === 'seq')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else {
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
          if (x.dataIndex === 'debit')
            colRenderer.Header = () => <span>Debit ({systemSettings?.primaryCurrency})</span>;
          else if (x.dataIndex === 'credit')
            colRenderer.Header = () => <span>Credit ({systemSettings?.primaryCurrency})</span>;
        }
      }

      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'exRate', changedValue: (value: any) => { return Decimalformat(value['exRate'], 4) } });
    colRenderer.push({ accessor: 'seq', changedValue: (value: any) => { return Decimalformat(value['seq'], 0) } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'updateDate',
      orderByAscending: false,
    };
  }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings =  accountingJournalList;
    const useBranch = systemSettings?.enableBranch ?? false;
    const cur = systemSettings?.primaryCurrency ?? 'USD';

    const cols = JournalLedgerListItem.getExportCollection(useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      const result = { ...x, accessor: x.dataIndex, Header:  x.text.replace('$$currency', cur), filterType: undefined, filterTypeV2: x.type};

      return result;
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderAfterConfigureButton() {
    return (
      <></>
    );
  }

  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: JournalLedgerListItem) {
    const fkey = row.fKey;
    const seq = row.seq;
    const type = row.type;
    const tbType = row.tbType;
    const viewUrl = `/accounting/acJournal/view/${fkey}/${seq}/${type}/${tbType}`;

    return row && row.id ? viewUrl : '';
  }

  getListViewTitle() {
    return 'Journal List';
  };

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
  
  hasMemo(): boolean {
    return false;
  }

  
  commandsAfterMemoLogBtn():React.ReactNode{
    //240904 All List버튼과 W/O Cancel/Reverse버튼 제거
    //return <AfterMemoLogButtonCommands />
    return null;
  }
}

export default JournalListView;
